import { Link, withRouter } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import { connect } from 'react-redux';
import { isImpersonating } from 'legacy/src/components/impersonating/utils';
import PropTypes from 'prop-types';
import React from 'react';

const LTILink = ({
  url,
  resourceId,
  chosenEducationPeriodCode,
  children,
  params,
  ...rest
}) => {
  const { subject: subjectId } = params;

  const formRef = React.createRef();
  const accountAccessToken = window.localStorage.getItem(
    'account_access_token',
  );

  return (
    <A11y>
      <form
        method="POST"
        action={`${FYM_BACKEND_URL}/lti/launch/${subjectId}/${resourceId}`}
        ref={formRef}
        target="POST"
      >
        <input type="hidden" name="jwt" value={accountAccessToken} />
        <input
          type="hidden"
          name="education_period"
          value={chosenEducationPeriodCode}
        />
        {isImpersonating() && (
          <input type="hidden" name="is_impersonating" value="1" />
        )}
        <Link
          data-test-subunit-url
          onClick={(e) => {
            e.preventDefault();
            formRef.current.submit();
          }}
          url={url}
          target="_blank"
          {...rest}
        >
          {children}
        </Link>
      </form>
    </A11y>
  );
};

LTILink.propTypes = {
  url: PropTypes.string.isRequired,
  resourceId: PropTypes.string.isRequired,
};

LTILink.defaultProps = {};

export default connect((state) => ({
  chosenEducationPeriodCode: state.userData.chosenEducationPeriodCode,
}))(withRouter(LTILink));
